// types
import { ContractStatus } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Typography } from '@mui/material';

// utils
import { translateContractStatus } from '../../../utils/translations';

// props
export interface ChipStatusProps extends ChipProps {
	status: ContractStatus | null | undefined;
}

export const ChipStatus = ({ color = 'default', status, ...props }: ChipStatusProps) => {
	// hooks
	const { t } = useTranslation();

	const colors: Record<ContractStatus, ChipProps['color']> = {
		ACTIVE: 'success',
		CANCELLED: 'error',
		COMPLETED: 'success',
		DEACTIVATED: 'error',
		DELETED: 'default',
		DRAFT: 'warning',
		SUBMITTED: 'info',
	};

	if (!status) {
		return <Typography>{t('na')}</Typography>;
	}

	return (
		<Chip
			color={colors[status] || color}
			label={translateContractStatus(status, t)}
			size="small"
			variant="twoTone"
			{...props}
		/>
	);
};
